import { RetellWebClient } from "retell-client-js-sdk";

const retellWebClient = new RetellWebClient();

export default retellWebClient;
